import { useWishlist } from '../hooks/useWishlist';

type WishlistContainerProps = { children: React.ReactNode };

const WishlistContainer = ({ children }: WishlistContainerProps) => {
	const { blockClass, componentId } = useWishlist();

	return (
		<div
			data-selection={componentId}
			className={`wishlistIconContainer wishlistIconContainer--${blockClass} vtex-wish-list-1-x-wishlistIconContainer ${blockClass && `vtex-wish-list-1-x-wishlistIconContainer--${blockClass}`}`}
		>
			{children}
		</div>
	);
};

export default WishlistContainer;
